import React, { useRef } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Slide } from '@fiverr-private/transition';
import { useLockBodyScroll, useClickOutside } from '@fiverr-private/hooks';
import { Portal } from '@fiverr-private/ui_utils';
import { GoMobileDrawerBody } from '../GoMobileDrawerBody';
import { GoTabProps } from '../GoSidebar.types';

interface GoMobileDrawerProps {
    tabs: GoTabProps[];
    homeUrl: string;
    backToFiverrUrl: string;
    isOpen?: boolean;
    onClose?: () => void;
}

export const GoMobileDrawer = ({ tabs, homeUrl, backToFiverrUrl, isOpen = false, onClose }: GoMobileDrawerProps) => {
    const drawerBodyRef = useRef<HTMLElement>(null);
    useLockBodyScroll(isOpen);
    useClickOutside(drawerBodyRef as React.RefObject<HTMLElement>, onClose);

    return (
        <Portal>
            <Container position="relative" zIndex="overlay">
                <Slide in={isOpen} direction="left" duration={{ enter: 'moderate2', exit: 'moderate1' }} unmountOnExit>
                    <GoMobileDrawerBody
                        tabs={tabs}
                        homeUrl={homeUrl}
                        backToFiverrUrl={backToFiverrUrl}
                        ref={drawerBodyRef}
                        onClose={onClose}
                    />
                </Slide>
            </Container>
        </Portal>
    );
};
